import dayjs from "dayjs";
import {
  BonificoOrderDTO,
  CalendarDate,
} from "../../ProductService/BonificoOrder/BonificoOrderDTO.ts";

export type ValueDateInvoices = {
  valueDate: CalendarDate;
  orders: BonificoOrderDTO[];
  totalAmountInCents: number;
};

export function groupAwaitingInvoicesByValueDate(
  orders: BonificoOrderDTO[],
): ValueDateInvoices[] {
  const ordersByValueDate = new Map<CalendarDate, BonificoOrderDTO[]>();
  for (const order of orders) {
    if (!order.valueDateUtc) continue;
    const valueDate = dayjs(order.valueDateUtc).format("YYYY-MM-DD");
    ordersByValueDate.set(valueDate, [
      ...(ordersByValueDate.get(valueDate) ?? []),
      order,
    ]);
  }
  return [...ordersByValueDate.entries()]
    .sort(([first], [second]) => first.localeCompare(second))
    .map(([valueDate, ordersOfTheDay]) => ({
      valueDate,
      orders: ordersOfTheDay,
      totalAmountInCents: ordersOfTheDay.reduce(
        (sum, order) => sum + (order.amountPaidInCents?.amount ?? 0),
        0,
      ),
    }));
}
